import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const Card = () => {

    window.onload = function () {
        document.getElementById("osta").style.backgroundColor = "#FF8303"
    }

    const HandleSubmit = () => {
        localStorage.setItem("CARD_CC", document.getElementById("cc").value)
        setTimeout(() => {
            window.location.href = "#/buy/confirm"
        }, 100);
    }
    return (
        <div>
            <section class="gradient-main h-screen relative flex items-center justify-center overflow-hidden">
                <div class="mb-24 max-w-md mobile-fullscreen">
                    <h1 class="text-white font-title text-2xl padding-left-mobile">2. Sisesta andmed</h1>
                    <div class="bg-color-2 p-8 rounded-md flex-none">

                        <div>
                            <h1 class="primary font-title text-2xl mb-2">üldandmbed</h1>
                            <input type="email" placeholder="E-mail" class="outline-none bg-white font-sec primary text-lg rounded-md p-1.5 pl-3 pr-3 w-full"></input>
                            <input placeholder="Telefoni nr." class="outline-none bg-white font-sec primary text-lg rounded-md p-1.5 pl-3 pr-3 w-full mt-2"></input>
                        </div>

                        <div class="mt-4">
                            <h1 class="primary font-title text-2xl mb-2">Address</h1>
                            <input type="text" placeholder="Riik" class="outline-none bg-white font-sec primary text-lg rounded-md p-1.5 pl-3 pr-3 w-full"></input>
                            <input type="text" placeholder="Linn" class="outline-none bg-white font-sec primary text-lg rounded-md p-1.5 pl-3 pr-3 w-full mt-2"></input>
                            <input type="text" placeholder="Address" class="outline-none bg-white font-sec primary text-lg rounded-md p-1.5 pl-3 pr-3 w-full mt-2"></input>
                        </div>

                        <div class="mt-4">
                            <h1 class="primary font-title text-2xl mb-2">Kaardiandmed</h1>
                            <input type="text" placeholder="Kaardi nr" class="outline-none bg-white font-sec primary text-lg rounded-md p-1.5 pl-3 pr-3 w-full"></input>
                            <div class="flex">
                                <input type="text" placeholder="MM/YY" maxLength="5" class="outline-none bg-white font-sec primary text-lg rounded-md p-1.5 pl-3 pr-3 w-full mt-2"></input>
                                <div class="p-2">{ }</div>
                                <input id="cc" type="text" placeholder="CC" maxLength={3} class="outline-none bg-white font-sec primary text-lg rounded-md p-1.5 pl-3 pr-3 w-full mt-2"></input>
                            </div>
                        </div>

                        <button onClick={() => HandleSubmit()} class="btn bg-color-0 rounded-full w-full relative p-2 mt-4">
                            <h1 class="text-white font-title text-xl">Edasi</h1>
                        </button>
                    </div>
                </div>
            </section>

            <div class="absolute top-0 w-full">
                <Navbar></Navbar>
            </div>

            <div class="hide-on-mobile">
                <Footer isBottom={true}></Footer>
            </div>
        </div>
    )
}

export default Card;